module.exports = __webpack_public_path__ + "static/img/tu5.7d5b4e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs/tu5.png
// module id = flwr
// module chunks = 1